<script setup lang="ts">
import { usePwaInstallBanner } from '../model/pwa-install-banner';
import { default as PwaInstallAction } from './PwaInstallAction.vue';
import { default as PwaInstallBannerTemplate } from './templates/PwaInstallBannerTemplate.vue';

const { isVisible, dismiss } = usePwaInstallBanner();
</script>

<template>
  <Transition
    enter-active-class="transition-[opacity] duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-[opacity] duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <PwaInstallBannerTemplate
      v-if="isVisible"
      @close="dismiss"
    >
      <PwaInstallAction label="Установить" />
    </PwaInstallBannerTemplate>
  </Transition>
</template>
